import $ from 'jquery';
import QRCode from 'qrcode';

export function DrawQRCode(qrContainter, link) {
    if (qrContainter !== null) {
        console.log(qrContainter);
        console.log(link);
        //new QRCode(qrContainter, link);
        QRCode.toCanvas(qrContainter, link);
    }
}

export function CompleteTotpRegistration(totp, completionUrl, completedUrl) {
    $.ajax({
        url: completionUrl,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({ TOTP: totp }),
        success: function (response) {
            if (response && isJsonString(response)) {
                let resTxt = JSON.parse(response);

                if (resTxt && resTxt.ErrorMessage.length > 0) {
                    $("#opterrorMessageIncorrect").show();
                }
            } else {
                window.location.href = completedUrl;
            }
        },
        error: function (jqXHR) {
            if (jqXHR.status === 401) {
                $("#opterrorMessageFailed").show();                
            }
        }
    });
}